import { Component, Input, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';

import { Dialog, DialogRef } from '../../../dialog.base';

@Component({
  selector: 'uex-dialog-header',
  templateUrl: './header.component.html',
  host: {
    class: 'uex-dialog-header modal-header'
  }
})
export class DialogHeaderComponent implements AfterViewInit, OnDestroy {
  @Input('alignItems') public alignItems: string = 'start';
  @Input('alignContent') public alignContent: string = null;
  @Input('justifyItems') public justifyItems: string = null;

  @Input('dialog')
  private set __dialog(dialog: Dialog) {
    this._dialog = dialog;
  }

  constructor(
    private _dialogRef: DialogRef,
    public elementRef: ElementRef
  ) { }

  private _dialog: Dialog;
  private _index: number;

  public ngAfterViewInit() {
    if (this._dialogRef.dialog) this._dialog = this._dialogRef.dialog;
    this._index = this._dialog.addHeader(this);
  }

  public ngOnDestroy() {
    this._dialog.removeHeader(this._index);
  }
}
